import { useEffect, useState } from "react";
import { BataiyoLogo } from "../../constant/ImagesS3";
import { ROUTES } from "../../constant/routes";
import "./PageNotFound.css";

function PageNotFound() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // redirect after 5 seconds
    const timer = setTimeout(() => {
      window.location.href = ROUTES.HOME;
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="page-not-found-container">
      <header className="page-not-found-header" role="banner">
        <div className="page-not-found-img-container">
          <img src={BataiyoLogo} alt="Bataiyo logo" loading="lazy" />
        </div>
      </header>
      <main role="main">
        <h1 className="not-found-first-heading" id="not-found-title">
          Page Not Found
        </h1>
        <p className="not-found-second-para">
          Redirecting you to{" "}
          <a href={ROUTES.HOME} className="home-link">
            www.bataiyo.com
          </a>{" "}
          in <strong>{countdown}</strong> seconds...
        </p>
      </main>
      <footer className="page-not-found-footer" role="contentinfo">
        <p>
          Copyright © {new Date().getFullYear()} Bgent Solutions Private
          Limited. All rights reserved
        </p>
      </footer>
    </div>
  );
}

export default PageNotFound;
